import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { Dialog } from '../../core/stores/DialogStore';
import { ButtonWidget } from '../controls/ButtonWidget';
import { useSystem } from '../../hooks/useSystem';
import { OverlayLayout } from '../layers/OverlayLayout';
import { Font } from '../../fonts';

export interface DialogWidgetProps {
  dialog: Dialog;
}

export const DialogWidget: React.FC<DialogWidgetProps> = (props) => {
  const { dialog } = props;
  return (
    <S.Dialog>
      <S.Heading>{dialog.title}</S.Heading>
      <S.Desc>{dialog.desc}</S.Desc>
      <S.Buttons>
        {dialog.btns.map((d) => {
          return <S.Btn {...d} key={d.label} />;
        })}
      </S.Buttons>
    </S.Dialog>
  );
};

export const DialogStoreWidget: React.FC = observer((props) => {
  const system = useSystem();
  const dialog = system.dialog_store.dialog;

  if (dialog) {
    return (
      <OverlayLayout>
        <DialogWidget dialog={dialog} />
      </OverlayLayout>
    );
  }
  return null;
});

namespace S {
  export const Heading = styled.div`
    font-family: ${Font.Special};
    font-size: 24px;
    color: ${(p) => p.theme.text.primary};
  `;

  export const Desc = styled.div`
    font-family: ${Font.Normal};
    font-size: 18px;
    color: ${(p) => p.theme.text.secondary};
  `;

  export const Buttons = styled.div`
    display: flex;
    column-gap: 5px;
    justify-content: flex-end;
  `;

  export const Btn = styled(ButtonWidget)`
    min-width: 60px;
  `;

  export const Dialog = styled.div`
    padding: 40px;
    border-radius: 10px;
    background: ${(p) => p.theme.layout.sidebar_background};
    border: solid 1px ${(p) => p.theme.layout.border};
    display: flex;
    flex-direction: column;
    row-gap: 20px;
  `;
}
